import { CreateModuleInstanceAttachmentDto } from "./../../model/module/dto/module-instance-attachment/CreateModuleInstanceAttachmentDto";
import { DeleteModuleInstanceAttachmentDto } from "./../../model/module/dto/module-instance-attachment/DeleteModuleInstanceAttachmentDto";
import { CreateModuleDefinitionDto } from "../../model/module/dto/module-definition/CreateModuleDefinitionDto";
import { DeleteModuleDefinitionDto } from "../../model/module/dto/module-definition/DeleteModuleDefinitionDto";
import { GetModuleInstancesByDefinitionIdDto } from "../../model/module/dto/module-definition/GetModuleInstancesByDefinitionIdDto";
import { GetUserModuleDefinitionsDto } from "../../model/module/dto/module-definition/GetUserModuleDefinitionsDto";
import { ModuleDefinitionSetPermissionsDto } from "../../model/module/dto/module-definition/ModuleDefinitionSetPermissionsDto";
import { UpdateModuleDefinitionDto } from "../../model/module/dto/module-definition/UpdateModuleDefinitionDto";
import { CreateModuleInstanceDto } from "../../model/module/dto/module-instance/CreateModuleInstanceDto";
import { DeleteModuleInstanceDto } from "../../model/module/dto/module-instance/DeleteModuleInstanceDto";
import { UpdateModuleInstanceDto } from "../../model/module/dto/module-instance/UpdateModuleInstanceDto";
import { ModuleDefinition } from "../../model/module/types/module-definition/ModuleDefinition";
import { BaseModuleInstance } from "../../model/module/types/module-instance/BaseModuleInstance";
import { PageResponseDto } from "../../model/shared/meta/PageResponseDto";
import { AtiraApi } from "../AxiosClient";
import { UpdateModuleInstanceAttachmentDto } from "../../model/module/dto/module-instance-attachment/UpdateModuleInstanceAttachmentDto";
import { GetModuleInstanceByIdDto } from "../../model/module/dto/module-instance/GetModuleInstanceByIdDto";

export class ModuleAxios {
  static getAllModuleDefinitions(dto: GetUserModuleDefinitionsDto) {
    return AtiraApi.get<ModuleDefinition[]>(
      `/module-definition/user/${dto.userId}`,
    ).then(({ data }) => data);
  }

  static createModuleDefinition(dto: CreateModuleDefinitionDto) {
    return AtiraApi.post("/module-definition/create", dto).then(
      ({ data }) => data,
    );
  }

  static updateModuleDefinition(dto: UpdateModuleDefinitionDto) {
    return AtiraApi.patch(
      `/module-definition/${dto.moduleDefinitionId}`,
      dto,
    ).then(({ data }) => data);
  }

  static createModuleInstance(dto: CreateModuleInstanceDto) {
    return AtiraApi.post("/module-instance/create", dto).then(
      ({ data }) => data,
    );
  }

  static updateModuleInstance(dto: UpdateModuleInstanceDto) {
    return AtiraApi.patch(`/module-instance/${dto.moduleInstanceId}`, dto).then(
      ({ data }) => data,
    );
  }

  static getModuleInstances(dto: GetModuleInstancesByDefinitionIdDto) {
    return AtiraApi.post<PageResponseDto<BaseModuleInstance[]>>(
      `/module-definition/${dto.moduleDefinitionId}/instances`,
      dto,
    ).then(({ data }) => data);
  }

  static deleteModuleInstance(dto: DeleteModuleInstanceDto) {
    return AtiraApi.delete(`/module-instance/${dto.moduleInstanceId}`, {
      data: dto,
    }).then(({ data }) => data);
  }

  static deleteModuleDefinition(dto: DeleteModuleDefinitionDto) {
    return AtiraApi.post<void>(
      `/module-definition/${dto.moduleDefinitionId}/delete`,
      dto,
    ).then(({ data }) => data);
  }

  static attachModuleInstanceToEntry(dto: CreateModuleInstanceAttachmentDto) {
    return AtiraApi.post(
      `/module-instance/${dto.moduleInstanceId}/attach/entry/${dto.entryId}`,
      dto,
    ).then(({ data }) => data);
  }

  static updateModuleInstanceAttachment(
    dto: UpdateModuleInstanceAttachmentDto,
  ) {
    return AtiraApi.patch<void>(
      `/module-instance-attachment/${dto.moduleInstanceAttachmentId}/entry/${dto.entryId}`,
      dto,
    ).then(({ data }) => data);
  }

  static detachModuleInstanceFromEntry(dto: DeleteModuleInstanceAttachmentDto) {
    return AtiraApi.delete<void>(
      `/module-instance-attachment/${dto.moduleInstanceId}`,
      { data: dto },
    ).then(({ data }) => data);
  }

  static manageModuleDefinitionPermissions(
    dto: ModuleDefinitionSetPermissionsDto,
  ) {
    return AtiraApi.post(
      `/module-definition/${dto.moduleDefinitionId}/manage-assignees`,
      dto,
    ).then(({ data }) => data);
  }

  static getModuleInstanceById(dto: GetModuleInstanceByIdDto) {
    return AtiraApi.post<BaseModuleInstance>(
      `/module-instance/${dto.moduleInstanceId}`,
      dto,
    ).then(({ data }) => data);
  }
}
